import { render, staticRenderFns } from "./CDRQOwner.vue?vue&type=template&id=7074c480&scoped=true&"
import script from "./CDRQOwner.vue?vue&type=script&lang=ts&"
export * from "./CDRQOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074c480",
  null
  
)

export default component.exports